<div class="print-content no-print-flexbox truespeed-content internal" #pdfPage *ngIf="!loading">
  <div layout="column" class="page" *ngIf="!public && !classicReport">
    <div class="page-break"></div>

    <div class="report-header">
      <img src="{{ logoUrl }}" class="truespeed-logo" />
      <div>
        <h2 class="truespeed-title">{{ reportTitle }}</h2>
      </div>
    </div>
    <hr />
    <div class="margin-10-left">
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style">
          <div class="header-class">Test Name</div>
          <div class="value-font">
            {{ requestInfo.testName }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Test Mode</div>
          <div class="value-font">
            {{ testMode }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Start Date</div>
          <div class="value-font">{{ startDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">End Date</div>
          <div class="value-font">{{ stopDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">Duration</div>
          <div class="value-font">{{ duration }}</div>
        </div>
        <div class="header-style" *ngIf="overallConfiguration">
          <div class="header-class">Test Points</div>
          <div class="value-font">
            {{ overallConfiguration.agent.primary.id }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            overallConfiguration &&
            overallConfiguration.agent.secondary &&
            overallConfiguration.agent.secondary.length > 0
          "
        >
          <div class="header-class"></div>
          <div
            class="value-font"
            *ngIf="
              overallConfiguration &&
              overallConfiguration.agent.secondary &&
              overallConfiguration.agent.secondary.length > 0
            "
          >
            {{ overallConfiguration.agent.secondary[0].id }}
          </div>
        </div>
      </div>
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style" *ngIf="requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.dmzUrl">
          <div class="header-class">DMZ Test URL</div>
          <div class="value-font">
            {{ requestInfo.dmzUrl }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.vtaTsUrl && overallConfiguration
          "
        >
          <div class="header-class">{{ getAgentURLLabel() }}</div>
          <div class="value-font">
            {{ requestInfo.vtaTsUrl }}
          </div>
        </div>
      </div>
      <div
        *ngIf="
          requestInfo?.customerInfo?.name ||
          requestInfo?.customerInfo?.contact ||
          requestInfo?.customerInfo?.phone ||
          requestInfo?.customerInfo?.email
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Customer</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">{{ requestInfo.customerInfo.name }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.contact">
              <div class="sec-header">Contact</div>
              <div class="sec-value">{{ requestInfo.customerInfo.contact }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.email">
              <div class="sec-header">Email</div>
              <div class="sec-value">{{ requestInfo.customerInfo.email }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.phone">
              <div class="sec-header">Phone</div>
              <div class="sec-value">{{ requestInfo.customerInfo.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="requestInfo?.techInfo?.name || requestInfo?.techInfo?.id">
        <div class="reports-customer-info">
          <div class="info-title">Technician</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.techInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">
                {{ requestInfo.techInfo.name }}
              </div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.techInfo?.id">
              <div class="sec-header">ID</div>
              <div class="sec-value">
                {{ requestInfo.techInfo.id }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 30px" *ngIf="requestInfo?.comments">
        <div class="header-style">
          <div class="header-class">Comments</div>
          <div class="value-font">
            {{ requestInfo.comments }}
          </div>
        </div>
      </div>
    </div>
    <hr />
    <h4 class="walk-header" *ngIf="overallVerdict === 'PASS'">
      Test Results - <span class="test-pass">Test Passed</span>
      <span class="test-warning" *ngIf="upstreamSummary.tcpLow || downstreamSummary.tcpLow"
        >with warnings</span
      >
    </h4>
    <h4 class="walk-header" *ngIf="overallVerdict === 'FAIL'">
      Test Results - <span class="test-fail">Test Failed</span>
    </h4>
    <div class="flex">
      <div class="walk-chart">
        <nrwl-trending-chart
          *ngIf="upstreamWindowResult"
          [options]="bulletChartOptions"
          id="bulletChart"
        ></nrwl-trending-chart>
        <div class="label">Mbps</div>
      </div>
      <div>
        <div layout="row" class="legend-row report-header">
          <span flex></span>
          <md-icon
            class="material-icons md-30 retrans-frames-icon diagnosis-head-left upstream-legend"
            >stop</md-icon
          >

          <span class="walk-chart-legend-text">Upstream </span>
          <div class="margin-5">
            <i class="mdi mdi-laptop icon"></i>
            <i class="mdi mdi-transfer-right icon"></i>
            <i class="mdi mdi-server icon"></i>
          </div>
          <span class="walk-chart-legend-text" *ngIf="isAgentToJmep">TCP Throughput </span>
        </div>

        <div *ngIf="!isAgentToJmep" layout="row" class="report-header">
          <span flex></span>
          <md-icon
            class="material-icons md-30 throughput-icon diagnosis-head-left downstream-legend"
            >stop</md-icon
          >
          <span class="walk-chart-legend-text" *ngIf="!isAgentToJmep">Downstream </span>
          <div class="margin-5" *ngIf="!isAgentToJmep">
            <i class="mdi mdi-laptop icon"></i>
            <i class="mdi mdi-transfer-left icon"></i>
            <i class="mdi mdi-server icon"></i>
          </div>
        </div>
        <div layout="row" class="report-header">
          <span flex></span>
          <md-icon
            class="material-icons md-30 retrans-frames-icon diagnosis-head-left walk-target-legend"
            >stop</md-icon
          >
          <span class="walk-chart-legend-text">Target</span>
        </div>
      </div>
    </div>
    <div class="test-result-table-panel">
      <table class="test-result-table">
        <tr>
          <th class="empty-column"></th>
          <th class="downstream-row" *ngIf="isAgentToJmep">Throughput</th>
          <th *ngIf="!isAgentToJmep" class="upstream-row">Upstream</th>
          <th class="downstream-row" *ngIf="!isAgentToJmep">Downstream</th>
        </tr>
        <tr>
          <td class="transperant-column">Verdict</td>
          <td class="upstream-column" *ngIf="!isAgentToJmep">
            <span [ngClass]="{ 'fail-verdict': upstreamSummary.verdict === 'FAIL' }">{{
              upstreamSummary.verdict
            }}</span>
            <span class="verdict-result"> {{ getVerdictMessage(upstreamSummary) }} </span>
          </td>
          <td class="downstream-column">
            <span [ngClass]="{ 'fail-verdict': downstreamSummary.verdict === 'FAIL' }">
              {{ downstreamSummary.verdict }}</span
            >
            <span class="verdict-result"> {{ getVerdictMessage(downstreamSummary) }} </span>
          </td>
        </tr>
        <tr>
          <td class="transperant-column">CIR</td>
          <td class="upstream-column" *ngIf="!isAgentToJmep">{{ upstreamSummary.cir }} Mbps</td>
          <td class="downstream-column">{{ downstreamSummary.cir }} Mbps</td>
        </tr>
        <tr>
          <td class="transperant-column">Target TCP throughput</td>
          <td *ngIf="!isAgentToJmep" class="upstream-column">{{ upstreamSummary.target }} Mbps</td>
          <td class="downstream-column">{{ downstreamSummary.target }} Mbps</td>
        </tr>
        <tr>
          <td class="transperant-column">Average TCP throughput</td>
          <td *ngIf="!isAgentToJmep" class="upstream-column">{{ upstreamSummary.bestAvg }} Mbps</td>
          <td class="downstream-column">{{ downstreamSummary.bestAvg }} Mbps</td>
        </tr>
        <tr *ngIf="!isThinClientTest">
          <td class="transperant-column">Peak TCP throughput</td>
          <td *ngIf="!isAgentToJmep" class="upstream-column">
            {{ upstreamSummary.bestPeak }} Mbps
          </td>
          <td class="downstream-column">{{ downstreamSummary.bestPeak }} Mbps</td>
        </tr>
        <tr>
          <td class="rtt-column">RTT <span class="normal-font">(round trip time)</span></td>
          <td *ngIf="isAgentToJmep" colspan="2" class="downstream-column">
            {{ testSummary.rttBase }} ms
          </td>
          <td *ngIf="!isAgentToJmep" colspan="2" class="rowspan-2-transperant-colunn">
            {{ testSummary.rttBase }} ms
          </td>
        </tr>
        <tr *ngIf="!isThinClientTest">
          <td class="rtt-column">TCP MSS</td>
          <td *ngIf="isAgentToJmep" colspan="2" class="downstream-column">
            {{ testSummary.mss }} bytes
          </td>
          <td *ngIf="!isAgentToJmep" colspan="2" class="rowspan-2-transperant-colunn">
            {{ testSummary.mss }} bytes
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div layout="column" class="page" *ngIf="!public && classicReport">
    <div class="page-break"></div>

    <div class="report-header">
      <img src="{{ logoUrl }}" class="truespeed-logo" />
      <h2 class="truespeed-title">{{ reportTitle }}</h2>
    </div>

    <hr />

    <table class="four-column-table" *ngIf="requestInfo">
      <tr>
        <th colspan="4">Test Request Info</th>
      </tr>

      <tr>
        <td>Technician Name</td>
        <td>{{ requestInfo.techInfo?.name }}</td>
        <td>Technician ID</td>
        <td>{{ requestInfo.techInfo?.id }}</td>
      </tr>

      <tr>
        <td>Customer Name</td>
        <td>{{ requestInfo.customerInfo?.contact }}</td>
        <td>Email</td>
        <td>{{ requestInfo.customerInfo?.email }}</td>
      </tr>

      <tr>
        <td>Phone</td>
        <td>{{ requestInfo.customerInfo?.phone }}</td>
        <td>Company</td>
        <td>{{ requestInfo.customerInfo?.name }}</td>
      </tr>

      <tr>
        <td>Test Name</td>
        <td>{{ testName }}</td>
        <td>Test Type</td>
        <td>{{ testMode }}</td>
      </tr>
      <tr>
        <td>Start Time</td>
        <td>{{ startDate | date: 'MM/dd/yyyy h:mm:ss a' }}</td>
        <td>End Time</td>
        <td>
          {{ stopDate | date: 'MM/dd/yyyy h:mm:ss a' }}
        </td>
      </tr>
      <tr *ngIf="requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.dmzUrl">
        <td>DMZ Test URL</td>
        <td colspan="3">
          <span>{{ requestInfo.dmzUrl }}</span>
        </td>
      </tr>
      <tr *ngIf="requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.vtaTsUrl">
        <td>vTA-TS Test URL</td>
        <td colspan="3">
          <span>{{ requestInfo.vtaTsUrl }}</span>
        </td>
      </tr>

      <tr>
        <td>Auth Code Creation Date</td>
        <td>{{ testSummary.start | date: 'MM/dd/yyyy' }}</td>
        <td>Expiration Date</td>
        <td *ngIf="requestInfo.mode !== 'CLIENT-TO-MA'">N/A</td>
        <td *ngIf="requestInfo.mode === 'CLIENT-TO-MA'">
          {{ requestInfo.expirationDate | date: 'MM/dd/yyyy HH:mm' }}
        </td>
      </tr>

      <tr>
        <td>Comments</td>
        <td colspan="3">
          {{ requestInfo.comments }}
        </td>
      </tr>
    </table>
  </div>
  <div layout="column" class="page" *ngIf="classicReport">
    <h4 class="walk-header test-pass font-size" *ngIf="overallVerdict === 'PASS'">
      Test Passed<span
        class="test-warning"
        *ngIf="upstreamSummary.tcpLow || downstreamSummary.tcpLow"
        >with warnings</span
      >
    </h4>
    <h4 class="walk-header test-fail font-size" *ngIf="overallVerdict === 'FAIL'">Test Failed</h4>
    <div class="page-break"></div>
    <div class="flex">
      <div layout="row" *ngIf="!isAgentToJmep" class="direction-container layout-row">
        <div class="barchart-panel">
          <div class="chart-header">
            <div class="margin-5">
              <i class="mdi mdi-laptop icon"></i>
              <i class="mdi mdi-transfer-right icon"></i>
              <i class="mdi mdi-server icon"></i>
            </div>

            <span class="direction">Upstream</span>

            <span flex="" class="flex"></span>

            <div layout="column" class="layout-column chart-right-section">
              <div layout="row" class="layout-row">
                <span class="span-img">
                  Target
                  <svg width="15" height="15" class="pos-relative">
                    <rect width="15" height="15" class="svg-right-color"></rect>
                  </svg>
                </span>
              </div>

              <div layout="row" class="layout-row">
                <span flex="" class="flex"> </span>
                <span class="span-img">
                  Actual
                  <svg width="15" height="15" class="chart-right-svg">
                    <rect width="15" height="15" class="svg-color2"></rect>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <nrwl-trending-chart
            *ngIf="upstreamWindowResult"
            [options]="
              transformService.createBarChart(
                isThinClientTest,
                'upstream',
                configuration,
                upstreamWindowResult.window,
                upstreamWindowResult.ideal,
                upstreamWindowResult.avg
              )
            "
            id="upstreamBarChart"
          ></nrwl-trending-chart>
        </div>

        <div *ngIf="resultType === 'FINAL'" class="chart-content-top">
          <span>CIR: {{ upstreamSummary.cir }} Mbps</span><br />
          <span
            >Target TCP Throughput:
            <span class="window-summary">{{ upstreamSummary.target }} Mbps</span> </span
          ><br />
          <span
            >Average TCP Throughput:
            <span class="window-summary-accent">{{ upstreamSummary.bestAvg }} Mbps</span> </span
          ><br />
          <span *ngIf="!isThinClientTest"
            >Peak TCP Throughput:
            <span class="window-summary-accent">{{ upstreamSummary.bestPeak }} Mbps</span> </span
          ><br />
        </div>
      </div>
      <div layout="row" class="direction-container layout-row second-chart-left">
        <div class="barchart-panel">
          <div class="chart-header">
            <div class="margin-5">
              <i class="mdi mdi-laptop icon"></i>
              <i class="mdi mdi-transfer-left icon"></i>
              <i class="mdi mdi-server icon"></i>
            </div>

            <span class="direction" *ngIf="!isAgentToJmep">Downstream</span>
            <span class="direction" *ngIf="isAgentToJmep">Throughput</span>

            <span flex="" class="flex"></span>

            <div layout="column" class="layout-column chart-right-section">
              <div layout="row" class="layout-row">
                <span class="span-img-downstream">
                  Target
                  <svg width="15" height="15" class="pos-relative">
                    <rect width="15" height="15" class="svg-right-color"></rect>
                  </svg>
                </span>
              </div>

              <div layout="row" class="layout-row">
                <span flex="" class="flex"> </span>
                <span class="span-img-downstream">
                  Actual
                  <!--<md-icon class="material-icons md-30  actual-icon actual-icon-MS-IE actual-icon-MS-Edge">stop</md-icon> -->
                  <svg width="15" height="15" class="chart-right-svg">
                    <rect width="15" height="15" class="svg-color2"></rect>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <nrwl-trending-chart
            *ngIf="downstreamWindowResult"
            [options]="
              transformService.createBarChart(
                isThinClientTest,
                'downstream',
                configuration,
                downstreamWindowResult.window,
                downstreamWindowResult.ideal,
                downstreamWindowResult.avg
              )
            "
            id="downstreamBarChart"
          ></nrwl-trending-chart>
        </div>
        <div *ngIf="resultType === 'FINAL'" class="chart-content-top">
          <span>CIR: {{ downstreamSummary.cir }} Mbps</span><br />
          <span
            >Target TCP Throughput:
            <span class="window-summary">{{ downstreamSummary.target }} Mbps</span> </span
          ><br />
          <span
            >Average TCP Throughput:
            <span class="window-summary-accent">{{ downstreamSummary.bestAvg }} Mbps</span> </span
          ><br />
          <span *ngIf="!isThinClientTest"
            >Peak TCP Throughput:
            <span class="window-summary-accent">{{ downstreamSummary.bestPeak }} Mbps</span>
          </span>
        </div>
      </div>
    </div>
    <div>
      <div *ngIf="!isThinClientTest" layout="row" class="test-summary-padding">
        <i class="mdi mdi-chevron-triple-right icon"></i>
        <span class="test-summary">TCP MSS: {{ testSummary.mss }} bytes</span>
      </div>

      <div *ngIf="!isThinClientTest" layout="row" class="test-summary-padding">
        <i class="mdi mdi-timer-outline icon"></i>
        <span class="test-summary">Round Trip Time: {{ testSummary.rttBase }} ms</span>
      </div>

      <div *ngIf="isThinClientTest" layout="row" class="test-summary-padding">
        <i class="mdi mdi-timer-outline icon"></i>
        <span class="test-summary"
          >Round Trip Time: {{ testSummary.rttBase }} ms
          <span class="rtt-subtext" *ngIf="!public"
            >(HTTPS: {{ testSummary.httpsRttAvg }} ms)</span
          ></span
        >
      </div>

      <div layout="row" class="test-verdict-padding" *ngIf="!public && !isAgentToJmep">
        <span *ngIf="!upstreamSummary.verdict">
          <strong>UPSTREAM: FAIL - </strong>
          <span> {{ getVerdictMessage(upstreamSummary) }} </span>
        </span>

        <span *ngIf="upstreamSummary.verdict">
          <strong>UPSTREAM: {{ upstreamSummary.verdict }} - </strong>
          <span>{{ getVerdictMessage(upstreamSummary) }} </span>
        </span>
      </div>

      <div layout="row" class="test-verdict-padding" *ngIf="!public">
        <span *ngIf="!downstreamSummary.verdict">
          <strong>DOWNSTREAM: FAIL - </strong>
          <strong *ngIf="!isAgentToJmep">DOWNSTREAM: FAIL - </strong>
          <strong *ngIf="isAgentToJmep">THROUGHPUT: FAIL - </strong>
          <span> {{ getVerdictMessage(downstreamSummary) }} </span>
        </span>

        <span *ngIf="downstreamSummary.verdict">
          <strong *ngIf="!isAgentToJmep">DOWNSTREAM: {{ downstreamSummary.verdict }} - </strong>
          <strong *ngIf="isAgentToJmep">THROUGHPUT: {{ downstreamSummary.verdict }} - </strong>
          <span>{{ getVerdictMessage(downstreamSummary) }} </span>
        </span>
      </div>
    </div>
  </div>
  <div layout="column" class="page" layout-padding *ngIf="!public && expertView === true">
    <div class="page-break"></div>
    <span>
      Note: “<strong>Average TCP Throughput</strong>”, “<strong>Actual Throughput</strong>”,
      “<strong>Buffer Delay</strong>”, and “<strong>TCP Efficiency</strong>” are measured over the
      portion of the test interval after equilibrium has been achieved.
    </span>

    <div class="diagnosis-head border">
      <div class="md-toolbar-tools diagnosis-head-left">
        <h2 class="md-flex diagnosis-header">Results Diagnosis</h2>
      </div>
    </div>
    <div class="border diagnosis-table" layout="column" layout-padding>
      <div layout="row" class="padding-8">
        <span *ngIf="!upstreamSummary.verdict">
          <strong>UPSTREAM: FAIL - </strong>
          <span>
            The throughput is less than
            {{
              getThresholdValueWithUnit(upstreamSummary.upStreamThresholdVal, upstreamSummary)
            }}
            of the target
          </span>
        </span>

        <span *ngIf="upstreamSummary.verdict">
          <strong>UPSTREAM: {{ upstreamSummary.verdict }} - </strong>
          <span>
            The throughput is
            <span *ngIf="upstreamSummary.verdict === 'FAIL'">less</span>
            <span *ngIf="upstreamSummary.verdict === 'PASS'">more</span>
            than
            {{
              getThresholdValueWithUnit(upstreamSummary.upStreamThresholdVal, upstreamSummary)
            }}
            of the target
          </span>
        </span>
      </div>

      <em
        *ngIf="
          upstreamSummary.diagnosis !== 'ALL_OK' &&
          upstreamSummary.diagnosis !== 'TCP_EFFICIENCY_LOW'
        "
      >
        Diagnosis is based on CIR window results
      </em>

      <div
        class="padding-1"
        *ngIf="
          upstreamSummary.diagnosis !== 'ALL_OK' &&
          upstreamSummary.diagnosis !== 'TCP_EFFICIENCY_LOW'
        "
      >
        <div *ngFor="let message of upstreamSummary.diagnosisMessage">
          <div layout="row" [ngClass]="{ indent: message && message.indexOf('8226') !== -1 }">
            <span [innerHTML]="message"></span>
          </div>
        </div>
      </div>

      <div layout="row" class="padding-8">
        <span *ngIf="!downstreamSummary.verdict">
          <strong>DOWNSTREAM: FAIL - </strong>
          <span>
            The throughput is less than
            {{
              getThresholdValueWithUnit(downstreamSummary.downStreamThresholdVal, downstreamSummary)
            }}
            of the target
          </span>
        </span>

        <span *ngIf="downstreamSummary.verdict">
          <strong>DOWNSTREAM: {{ downstreamSummary.verdict }} - </strong>
          <span>
            The throughput is
            <span *ngIf="downstreamSummary.verdict === 'FAIL'">less</span>
            <span *ngIf="downstreamSummary.verdict === 'PASS'">more</span>
            than
            {{
              getThresholdValueWithUnit(downstreamSummary.downStreamThresholdVal, downstreamSummary)
            }}
            of the target
          </span>
        </span>
      </div>

      <em
        *ngIf="
          downstreamSummary.diagnosis !== 'ALL_OK' &&
          downstreamSummary.diagnosis !== 'TCP_EFFICIENCY_LOW'
        "
      >
        Diagnosis is based on CIR window results
      </em>

      <div
        class="padding-1"
        *ngIf="
          downstreamSummary.diagnosis !== 'ALL_OK' &&
          downstreamSummary.diagnosis !== 'TCP_EFFICIENCY_LOW'
        "
      >
        <div *ngFor="let message of downstreamSummary.diagnosisMessage">
          <div layout="row" [ngClass]="{ indent: message && message.indexOf('8226') !== -1 }">
            <span [innerHTML]="message"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div layout="column" class="page" *ngIf="!public">
    <div class="page-break"></div>
    <span class="page-title"> TrueSpeed Test Configs </span>
    <nrwl-report-view-table
      [dataSource]="testConfigsDataSource"
      [displayedColumns]="displayedColumns"
    ></nrwl-report-view-table>
  </div>
  <div layout="column" class="page" *ngIf="!public && !isThinClientTest">
    <div class="page-break"></div>
    <span class="page-title"> TrueSpeed Test Results </span>
    <nrwl-report-view-table
      [dataSource]="testResultsDataSource"
      [displayedColumns]="displayedColumns"
    ></nrwl-report-view-table>
  </div>
  <div
    layout="column"
    class="page"
    *ngIf="
      !public &&
      requestInfo.mode === 'CLIENT-TO-MA' &&
      hasClientInfo &&
      ((expertView === true && !isThinClientTest) || isThinClientTest)
    "
  >
    <div class="page-break"></div>
    <span class="page-title"> Client configuration</span>
    <nrwl-report-view-table
      [dataSource]="clientInfoDataSource"
      [displayedColumns]="displayedColumns"
    ></nrwl-report-view-table>
    <div layout="column" class="trending-chart-container" *ngIf="!isThinClientTest">
      <div class="grid">
        <div layout="row" class="legend-row">
          <span flex></span>
          <span class="legend"
            >CPU Usage (%)
            <md-icon class="material-icons md-30 cpu-icon diagnosis-head-left">stop</md-icon>
          </span>
        </div>
      </div>
      <nrwl-trending-chart
        [options]="transformService.createCpuChart(clientCpuUsage, 'client')"
        id="cpu-chart"
      ></nrwl-trending-chart>
    </div>
  </div>
  <div
    layout="column"
    class="page"
    *ngIf="
      !public &&
      requestInfo.mode === 'CLIENT-TO-MA' &&
      hasClientInfo &&
      expertView === true &&
      !isThinClientTest
    "
  >
    <div class="page-break"></div>
    <div layout="column" class="trending-chart-container">
      <div class="grid">
        <div layout="row" class="legend-row">
          <span flex></span>
          <span class="legend"
            >Memory Usage (%)
            <md-icon class="material-icons md-30 cpu-icon diagnosis-head-left">stop</md-icon>
          </span>
        </div>
      </div>
      <nrwl-trending-chart
        [options]="transformService.createMemoryUsageChart(clientMemoryUsage, 'client')"
        id="memory-chart"
      ></nrwl-trending-chart>
    </div>
  </div>
  <div layout="column" *ngIf="!public && !isThinClientTest">
    <ng-container>
      <div *ngFor="let windowResult of windowSummary; let i = index">
        <div class="page" layout="column">
          <div class="page-break"></div>

          <span class="page-title" *ngIf="!isAgentToJmep">
            {{ windowResult.title }}
          </span>
          <span class="page-title" *ngIf="isAgentToJmep">
            {{ windowResult.title }}
          </span>

          <nrwl-report-view-table
            [dataSource]="getwindowResultDataSource(windowResult)"
            [displayedColumns]="displayedColumns"
          ></nrwl-report-view-table>

          <!--Throughput/Retransmit Chart -->
          <div layout="column" class="trending-chart-container">
            <div class="grid" *ngIf="classicReport">
              <div layout="row" class="legend-row">
                <span flex></span>
                <span class="legend"
                  >TCP Throughput (Mbps)
                  <md-icon class="material-icons md-30 throughput-icon diagnosis-head-left"
                    >stop</md-icon
                  >
                </span>
              </div>

              <div layout="row">
                <span flex></span>
                <span class="span-icon" class="legend"
                  >TCP Retransmitted Frames
                  <md-icon class="material-icons md-30 retrans-frames-icon diagnosis-head-left"
                    >stop</md-icon
                  >
                </span>
              </div>
            </div>
            <div class="column-line-chart-margin">
              <nrwl-trending-chart
                *ngIf="!classicReport"
                [options]="
                  transformService.createTrendingColumnAndLineChart(
                    isThinClientTest,
                    configuration,
                    isAgentToJmep
                      ? windowResults[0]
                      : getMatchedWindowResult(windowResult['window-id']),
                    'retrans_frame',
                    windowResult.direction
                  )
                "
                id="window  {{ windowResult['window-id'] }} ThroughputRetransmit"
              ></nrwl-trending-chart>
            </div>
            <nrwl-trending-chart
              *ngIf="classicReport"
              [options]="
                transformService.createTrendingChart(
                  isThinClientTest,
                  configuration,
                  isAgentToJmep
                    ? windowResults[0]
                    : getMatchedWindowResult(windowResult['window-id']),
                  'retrans_frame'
                )
              "
              id="window {{ windowResult['window-id'] }} ThroughputRetransmit"
            ></nrwl-trending-chart>
          </div>
        </div>

        <div class="page" layout="column">
          <div class="page-break"></div>

          <!--Throughput/RetrainsRatio Chart -->
          <div layout="column" class="trending-chart-container">
            <div class="grid" *ngIf="classicReport">
              <div layout="row" class="legend-row">
                <span flex></span>
                <span class="legend"
                  >TCP Throughput (Mbps)
                  <md-icon class="material-icons md-30 throughput-icon diagnosis-head-left"
                    >stop</md-icon
                  >
                </span>
              </div>

              <div layout="row">
                <span flex></span>
                <span class="span-icon" class="legend"
                  >TCP Retransmit Ratio (%)
                  <md-icon class="material-icons md-30 retrans-ratio-icon diagnosis-head-left"
                    >stop</md-icon
                  >
                </span>
              </div>
            </div>
            <div class="column-line-chart-margin">
              <nrwl-trending-chart
                *ngIf="!classicReport"
                [options]="
                  transformService.createTrendingColumnAndLineChart(
                    isThinClientTest,
                    configuration,
                    isAgentToJmep
                      ? windowResults[0]
                      : getMatchedWindowResult(windowResult['window-id']),
                    'retrans_ratio',
                    windowResult.direction
                  )
                "
                id="window  {{ windowResult['window-id'] }} ThroughputRetransmitRatio"
              ></nrwl-trending-chart>
            </div>
            <nrwl-trending-chart
              *ngIf="classicReport"
              [options]="
                transformService.createTrendingChart(
                  isThinClientTest,
                  configuration,
                  isAgentToJmep
                    ? windowResults[0]
                    : getMatchedWindowResult(windowResult['window-id']),
                  'retrans_ratio'
                )
              "
              id="window {{ windowResult['window-id'] }} ThroughputRetransmitRatio"
            ></nrwl-trending-chart>
          </div>

          <!--Throughput/RTT Chart -->
          <div layout="column" class="trending-chart-container">
            <div class="grid" *ngIf="classicReport">
              <div layout="row" class="legend-row">
                <span flex></span>
                <span class="legend"
                  >TCP Throughput (Mbps)
                  <md-icon class="material-icons md-30 throughput-icon diagnosis-head-left"
                    >stop</md-icon
                  >
                </span>
              </div>

              <div layout="row">
                <span flex></span>
                <span class="span-icon legend"
                  >RTT (ms)
                  <md-icon class="material-icons md-30 rtt-icon diagnosis-head-left">stop</md-icon>
                </span>
              </div>
            </div>
            <div class="column-line-chart-margin">
              <nrwl-trending-chart
                *ngIf="!classicReport"
                [options]="
                  transformService.createTrendingColumnAndLineChart(
                    isThinClientTest,
                    configuration,
                    isAgentToJmep
                      ? windowResults[0]
                      : getMatchedWindowResult(windowResult['window-id']),
                    'rtt',
                    windowResult.direction
                  )
                "
                id="window  {{ windowResult['window-id'] }} ThroughputRtt"
              ></nrwl-trending-chart>
            </div>
            <nrwl-trending-chart
              *ngIf="classicReport"
              [options]="
                transformService.createTrendingChart(
                  isThinClientTest,
                  configuration,
                  isAgentToJmep
                    ? windowResults[0]
                    : getMatchedWindowResult(windowResult['window-id']),
                  'rtt'
                )
              "
              id="window  {{ windowResult['window-id'] }} ThroughputRtt"
            ></nrwl-trending-chart>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div layout="column" *ngIf="!public && isThinClientTest">
    <ng-container *ngIf="windowResults && windowResults.length > 0">
      <div *ngFor="let windowResult of windowSummary; let i = index">
        <div class="page" layout="column">
          <div class="page-break"></div>

          <span class="page-title">
            {{ windowResult.title }}
          </span>

          <nrwl-report-view-table
            [dataSource]="getThinClientwindowResultDataSource(windowResult)"
            [displayedColumns]="displayedColumns"
          ></nrwl-report-view-table>

          <!--Throughput/Retransmit Chart -->
          <div layout="column" class="trending-chart-container">
            <div class="grid" *ngIf="classicReport">
              <div layout="row" class="legend-row">
                <span flex></span>
                <span class="legend"
                  >TCP Throughput (Mbps)
                  <md-icon class="material-icons md-30 throughput-icon diagnosis-head-left"
                    >stop</md-icon
                  >
                </span>
              </div>

              <div layout="row">
                <span flex></span>
                <span class="span-icon" class="legend"
                  >TCP Retransmitted Frames
                  <md-icon class="material-icons md-30 retrans-frames-icon diagnosis-head-left"
                    >stop</md-icon
                  >
                </span>
              </div>
            </div>
            <div class="column-line-chart-margin">
              <nrwl-trending-chart
                *ngIf="!classicReport"
                [options]="
                  transformService.createTrendingColumnAndLineChart(
                    isThinClientTest,
                    configuration,
                    isAgentToJmep ? windowResults[0] : windowResults[i],
                    'retrans_frame',
                    windowResult.direction
                  )
                "
                id="window  {{ windowResult['window-id'] }} ThroughputRetransmit"
              ></nrwl-trending-chart>
            </div>
            <nrwl-trending-chart
              *ngIf="classicReport"
              [options]="
                transformService.createTrendingChart(
                  isThinClientTest,
                  configuration,
                  isAgentToJmep ? windowResults[0] : windowResults[i],
                  'retrans_frame'
                )
              "
              id="window {{ windowResult['window-id'] }} ThroughputRetransmit"
            ></nrwl-trending-chart>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div
    id="appendix"
    layout="column"
    class="page"
    *ngIf="!public && requestInfo.mode === 'CLIENT-TO-MA' && hasClientInfo && expertView === true"
  >
    <div class="page-break"></div>

    <div class="page-title">Appendix</div>

    <div class="diagnosis-head border">
      <div class="md-toolbar-tools diagnosis-head-left">
        <h2 class="md-flex header-font">Client Process Snapshot</h2>
      </div>
    </div>

    <div class="border appendix" layout="column" layout-padding>
      <div *ngFor="let property of clientInfo.processes | keyvalue" class="line-height-2">
        <span>
          {{ property.key }}
          <span *ngIf="property.value !== 1">({{ property.value }} processes)</span>
        </span>
      </div>
    </div>
  </div>

  <div
    fxLayout="column"
    class="page"
    fxLayoutGap="16px"
    *ngIf="reportmessage && reportmessage?.length !== 0"
  >
    <div class="page-break"></div>

    <mat-toolbar class="diagnosis-head border">
      <div class="mat-toolbar-tools">
        <h2 class="mat-flex">Report Message</h2>
      </div>
    </mat-toolbar>

    <mat-card class="border" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="row">
        <span>{{ reportmessage }}</span>
      </div>
    </mat-card>
  </div>
</div>
<div class="truespeed-content">
  <div class="loader-content" *ngIf="loading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Getting Reports</div>
    </div>
  </div>
</div>
